import { render, staticRenderFns } from "./MixCouveturesFromShelf_SingleItem.vue?vue&type=template&id=70f6b90d"
import script from "./MixCouveturesFromShelf_SingleItem.vue?vue&type=script&lang=js"
export * from "./MixCouveturesFromShelf_SingleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports